module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Profitez de la livraison gratuite le jour même',
        trialContentStart: 'Commencez à économiser avec un',
        freeTrial: 'essai GRATUIT de 30 jours',
        sameDayUnlimited: 'Same Day Unlimited',
        trialContentEnding: 'de la livraison le jour même illimitée de Sephora.',
        subscriptionContentStart: 'Commencez à économiser avec la livraison le jour même illimitée de Sephora. Abonnez-vous pour seulement ',
        annually: 'chaque année.',
        signUp: 'S’inscrire'
    };

    return resources[label];
};
